export default __webpack_public_path__ + "static/media/bg-sm@2x.e72ae413.webp";